// extracted by mini-css-extract-plugin
export default {"coins":"GwFoGwXrzyVlwZLC6ByX0A=="};